export default __webpack_public_path__ + "static/media/iso_45001.1e8669c1.jpg";